/* eslint-disable */

import { showDefaultErrorMessage } from '@/utils/createMessage'
import {
  SET_REPORT,
  CHANGE_LOADING
} from '@/store/mutationsTypes'
import Api from '@/repository/index'
const GENERATE_TABLE_VIEW_BY_PEROPT = 'TOGGLE_ADD_PERCENT'
const CHANGE_TABLE_VIEW_CHECK = 'CHANGE_TABLE_VIEW'
const CHANGE_SCHECKED_STATUS_ON_COLUMNS = 'CHANGE_SCHECKED_STATUS_ON_COLUMNS'
const CHANGE_IS_SHOW_HIDE_COLUMNS = 'CHANGE_IS_SHOW_HIDE_COLUMNS'
const SHOW_TABLE_COLUMNS = 'SHOW_TABLE_COLUMNS'
const SET_CHANGE = 'SET_CHANGE'

const state = () => ({
  tableView: [],
  isLoading: false,
  isShowHideColumns: false,
  change: 'common',

  hideColumns: ['ГИБДД', 'Депозит', 'Омыватель', 'Внутренняя страховка', 'Рассрочка', 'Внутренний штраф', 'Другое', 'Эффективность', 'Опоздания', 'Не заправлен БЕНЗИН', 'Не заправлен ГАЗ', 'Курение', 'Грязный авто', 'ДТП', 'Смена', 'Смена НДС', 'Работа камеры', 'Крепеж камеры', 'Авто в личных целях'],
  consolidatedReport: [],
  columnsDesctiption: [
    {
      columnName: 'Всего возможных аренд (12ч) - ВСЕГО',
      description: 'Общее количество возможных арендных периодов (12ч), учитывая все автомобили, в т.ч. в ремонте и органическом простое.'
    },
    {
      columnName: 'Количество простоев (12ч) из-за ремонта',
      description: 'Общее количесто смен, в которое автомобили находились в краткосрочном, среднесрочном и долгосрочном ремонте.'
    },
    {
      columnName: 'Количество упущенных аренд ВСЕГО',
      description: 'Общее количесто смен, в которое автомобили находились в органическом простое, без учета автомобилей в ремонте'
    },
    {
      columnName: '% загрузки',
      description: 'Средний % загрузки автопарка, учитывая органический и ремонтный простой.'
    },
    {
      columnName: '% ремонта',
      description: 'Средний % арендных периодов затраченных на ремонт относительно общего количества арендных периодов.'
    },
    {
      columnName: '% простоя с ремонтом',
      description: 'Средний % органического простоя. Автомобили в работоспособном состоянии, но не сданные в аренду.'
    },
    {
      columnName: 'Накат',
      description: 'Общий накат, полученный от использования автомобилей'
    },
    {
      columnName: 'Накат',
      description: 'Общий накат, полученный от использования автомобилей'
    },
    {
      columnName: 'Валовый доход арендатора',
      description: 'Общий доход арендаторов, полученный от использования автомобилей без учета комиссий агрегаторов, партнера и т.д.'
    }

  ]
})
// const helpers = {
//   lineСontainsСhange (string, change, type) {
//     const [isMorning, isNight, isFullDay] = [string.endsWith('ВСЕГО'), string.endsWith('ДЕНЬ'), string.endsWith('НОЧЬ'), string.endsWith('24ч')]
//     // const [isCummon, isMorning, isNight] = [type === 'common', type === 'morning', type === 'night']
//     // if (isCummon) return true

//     // if (change === 'common') return true
//     if (change === 'morning' && isMorning) return true
//     if (change === 'night' && isNight) return true
//     if (change === 'fullday' && isFullDay) return true

//     // if (change === 'common') return false
//     // if (!string.includes('(')) return false
//     // if (type === 'morning' && change === 'night') return false
//     // if (type === 'night' && change === 'morning') return false
//     return false
//   }
// }
const getters = {
  getCheckedColumns: (state, getters) => {
    const checkedColumns = [...getters.getOnlyTitlesCheckedColumns]
    return state.consolidatedReport.reduce((accamulatorReport, reportCurrentValue) => {
      const { columns } = reportCurrentValue

      if (!columns) return [...accamulatorReport]

      const redusedColumns = columns.reduce((acc, e) => {
        if (checkedColumns.includes(e.title)) {
          return { ...acc, [e.title]: e.result, ...reportCurrentValue.period }
        }

        return { ...acc }
      }, {})

      return [redusedColumns, ...accamulatorReport]
    }, [])
  },
  getOnlyTitlesCheckedColumns: (state) => {
    return state.tableView
      // .filter(e => e?.checked && !helpers.lineСontainsСhange(e.title, state.change, e.type))
      .filter(e => {
        return e?.checked && (state.change === 'common' || e.type === 'common' || state.change === e.type)
      })
      .map(element => element.title)
  },
  checkDesctiptionItem: (state) => {
    return (columnName) => {
      return state?.columnsDesctiption.filter(t => t.columnName.includes(columnName))
    }
  }
}

const mutations = {

  [CHANGE_TABLE_VIEW_CHECK]: (state, index) => {
    state.tableView[index].checked = !state.tableView[index].checked
  },

  [SHOW_TABLE_COLUMNS]: (state, namesArray) => {
    const result = state.tableView.map((e) => {
      const item = e
      item.checked = namesArray.includes(item.name)
      return item
    })

    state.tableView = result
  },

  [SET_REPORT]: (state, report) => {
    state.consolidatedReport = report
  },
  [CHANGE_IS_SHOW_HIDE_COLUMNS]: (state) => {
    state.isShowHideColumns = !state.isShowHideColumns
  },
  [CHANGE_SCHECKED_STATUS_ON_COLUMNS]: (state) => {
    state.tableView = state.tableView.reduce((acc, cur, index, array) => {
      if (state.hideColumns.some(v => cur.title === v)) {
        return [
          ...acc,
          {
            title: cur.title,
            checked: state.isShowHideColumns,
            name: cur.name,
            type: cur.type
          }
        ]
      }
      return [...acc, { ...cur }]
    }, []) || []
  },
  [CHANGE_LOADING]: (state, value) => {
    state.isLoading = value
  },
  [SET_CHANGE]: (state, value) => {
    state.change = value
  },
  [GENERATE_TABLE_VIEW_BY_PEROPT]: (state) => {
    if (state.tableView.length > 0 && state.tableView.length === state?.consolidatedReport[0]?.columns.length && state.tableView[0]?.type) return
    state.tableView = state?.consolidatedReport[0]?.columns.reduce((acc, cur) => {
      return [
        ...acc,
        {
          title: cur?.title,
          checked: true,
          name: cur?.name,
          type: cur?.type
        }
      ]
    }, []) || []
  }
}

const actions = {

  async changeTableColumnVisibility ({ commit }, getIndex) {
    try {
      commit(CHANGE_TABLE_VIEW_CHECK, getIndex)
    } catch (e) {
      return Promise.reject(e)
    }
  },

  showTableColumns ({ commit }, namesArray) {
    commit(SHOW_TABLE_COLUMNS, namesArray)
  },

  async setCheckedOrUncheckedSpecificColumns ({ commit }) {
    try {
      commit(CHANGE_IS_SHOW_HIDE_COLUMNS)
      commit(CHANGE_SCHECKED_STATUS_ON_COLUMNS)
    } catch (e) {
      return Promise.reject(e)
    }
  },

  async setChange ({ commit }, someChange) {
    try {
      commit(SET_CHANGE, someChange)
    } catch (e) {
      return Promise.reject(e)
    }
  },
  async fetchReportConsolidatedInRange ({ commit }, { start: startDate, end: endDate, region_park_id: regionParkId }) {
    try {
      commit(CHANGE_LOADING, true)
      const report = await Api.monthly.getMonthlyReport({ startDate, endDate, regionParkId })
      await commit(SET_REPORT, report)

      commit(GENERATE_TABLE_VIEW_BY_PEROPT, report)
      commit(CHANGE_SCHECKED_STATUS_ON_COLUMNS)
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    } finally {
      commit(CHANGE_LOADING, false)
    }
  },
  async fetchReportMaintenanceInRange ({ commit }, { start: startDate, end: endDate, warehouseId }) {
    try {
      commit(CHANGE_LOADING, true)
      const report = await Api.monthlyMaintenance.getMonthlyMaintenanceReport({ startDate, endDate, warehouseId })
      await commit(SET_REPORT, report)

      commit(GENERATE_TABLE_VIEW_BY_PEROPT, report)
      commit(CHANGE_SCHECKED_STATUS_ON_COLUMNS)
    } catch (err) {
      showDefaultErrorMessage()
      return Promise.reject(err)
    } finally {
      commit(CHANGE_LOADING, false)
    }
  }

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
